export const CREATE_MEDICINE_REQUEST = 'CREATE_MEDICINE_REQUEST'
export const CREATE_MEDICINE_SUCCESS = 'CREATE_MEDICINE_SUCCESS'
export const CREATE_MEDICINE_FAIL = 'CREATE_MEDICINE_FAIL'
export const CREATE_MEDICINE_RESET = 'CREATE_MEDICINE_RESET'


export const LIST_MEDICINE_REQUEST = 'LIST_MEDICINE_REQUEST'
export const LIST_MEDICINE_SUCCESS = 'LIST_MEDICINE_SUCCESS'
export const LIST_MEDICINE_FAIL = 'LIST_MEDICINE_FAIL'
export const LIST_MEDICINE_RESET = 'LIST_MEDICINE_RESET'

export const DELETE_MEDICINE_REQUEST = 'DELETE_MEDICINE_REQUEST'
export const DELETE_MEDICINE_SUCCESS = 'DELETE_MEDICINE_SUCCESS'
export const DELETE_MEDICINE_FAIL = 'DELETE_MEDICINE_FAIL'

export const UPDATE_MEDICINE_REQUEST = 'UPDATE_MEDICINE_REQUEST'
export const UPDATE_MEDICINE_SUCCESS = 'UPDATE_MEDICINE_SUCCESS'
export const UPDATE_MEDICINE_FAIL = 'UPDATE_MEDICINE_FAIL'
export const UPDATE_MEDICINE_RESET = 'UPDATE_MEDICINE_RESET'


export const DETAILS_MEDICINE_REQUEST = 'DETAILS_MEDICINE_REQUEST'
export const DETAILS_MEDICINE_SUCCESS = 'DETAILS_MEDICINE_SUCCESS'
export const DETAILS_MEDICINE_FAIL = 'DETAILS_MEDICINE_FAIL'


export const LIST_TYPE_ENUMS_REQUEST = 'LIST_TYPE_ENUMS_REQUEST'
export const LIST_TYPE_ENUMS_SUCCESS = 'LIST_TYPE_ENUMS_SUCCESS'
export const LIST_TYPE_ENUMS_FAIL = 'LIST_TYPE_ENUMS_FAIL'
export const LIST_TYPE_ENUMS_RESET = 'LIST_TYPE_ENUMS_RESET'